import { chatHistoryAPI } from './api';

export interface ChatSession {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  message_count: number;
  last_message: string | null;
}

export interface ChatHistoryMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  created_at: string;
}

export async function getChatSessions(limit: number = 50): Promise<{ sessions: ChatSession[]; error: string | null }> {
  try {
    const sessions = await chatHistoryAPI.getSessions(limit);
    return { sessions, error: null };
  } catch (error: any) {
    return { sessions: [], error: error?.message || '获取会话列表失败' };
  }
}

export async function getChatSessionMessages(sessionId: string): Promise<{ messages: ChatHistoryMessage[]; error: string | null }> {
  try {
    const messages = await chatHistoryAPI.getSessionMessages(sessionId);
    return { messages, error: null };
  } catch (error: any) {
    return { messages: [], error: error?.message || '获取会话消息失败' };
  }
}

export async function createChatSession(title?: string): Promise<{ id: string | null; error: string | null }> {
  try {
    const response = await chatHistoryAPI.createSession(title);
    return { id: response.id, error: null };
  } catch (error: any) {
    return { id: null, error: error?.message || '创建会话失败' };
  }
}

export async function createChatMessage(
  sessionId: string,
  data: { role: 'user' | 'assistant' | 'system'; content: string }
): Promise<{ success: boolean; error: string | null }> {
  try {
    const response = await chatHistoryAPI.createMessage(sessionId, data);
    return { success: !!response.success, error: null };
  } catch (error: any) {
    return { success: false, error: error?.message || '保存消息失败' };
  }
}

